import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { monthlyDropdownList, monthlyOverviewChart } from "../../../Data/Dashboard/Default";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader";

const SellOverview = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Sell Overview"} />
        <CardBody className="py-0 ps-0">
          <div className="monthly-overview">
            <ReactApexChart
              options={monthlyOverviewChart}
              series={monthlyOverviewChart.series}
              type="bar"
              height={250}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default SellOverview;
